export default __webpack_public_path__ + "static/media/home_group_avatar.168e85fb.svg";